export enum EAccountType {
    PERFORMANCE,
    CLINIC
}
